import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { fetchCategoryCollections } from '../../store/collections/collections.slice';
import { AppDispatch, RootState } from '../../store/store';
import Navbar from 'components/navbar';
import BestInfluencers from 'components/creater/best-influencers';
import { DisplayThemeProps } from 'interfaces/category/DisplayThemeProps';

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import { Collection } from 'api/collections/types';
import { Category } from 'api/categories/types';
import Footer from 'components/footer';
import { getNextStage } from 'utils/helpers/collectionHelper';
import { formatSalePrice } from 'utils/helpers/formatHelper';
import { useTranslation } from 'react-i18next';
import LazyImage from 'components/lazy-image';
import CategoryBadge from 'components/collection/category-badge';
import { Helmet } from 'react-helmet-async';

const DisplayTheme2: React.FC<DisplayThemeProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const { categoryCollections } = useSelector((state: RootState) => state.collections);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    useEffect(() => {
        dispatch(fetchCategoryCollections({
            category_slug: props.category.slug,
            collection_fields: 'owner,categories,stages,contracts'
        }));
    }, [dispatch, props]);

    

  const settings = {
    container: '.tiny-five-item',
    controls: false,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    speed: 400,
    gutter: 12,
    responsive: {
        1025: {
            items: 5
        },

        992: {
            items: 3
        },

        767: {
            items: 2
        },

        320: {
            items: 1
        },
    },
  };

    return categoryCollections && (
        <>
        <Helmet>
            <title>{props.category.name} - {process.env.REACT_APP_NAME}</title>
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'WebSite',
                    name: process.env.REACT_APP_NAME,
                    url: window.location.origin
                })}
            </script>
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    name: process.env.REACT_APP_NAME,
                    url: window.location.origin,
                    logo: window.location.origin + '/assets/images/logo-light.webp',
                })}
            </script>
        </Helmet>
        <Navbar navlight={true} gradient={true} />
        <section className="bg-half-170 d-table w-100 position-relative">
            <img alt="demo" src="https://res.cloudinary.com/deoakqavp/image/upload/v1736792938/categories/conmebol.webp" className="w-100 h-100 position-absolute top-0 start-0" style={{ objectFit: 'cover', zIndex: -1 }} />
        </section>
        <div className="position-relative">            
            <div className="shape overflow-hidden text-shape">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <section className="bg-half-174">
          <div className="container-fluid">
              <div className="row">
                  <div className="col-12">
                      <div className="tiny-five-item">
                        <TinySlider settings={settings}>
                          {categoryCollections.data.map((item: Collection,index)=>{
                            const stage = getNextStage(item?.stages || [], userTimeZone);
                            const contract = item?.contracts && item.contracts.length > 0 ? item.contracts[0] : null;
                            return(
                              <div className="tiny-slide" key={index}>
                                <div className="card bg-white nft-items nft-primary rounded-md shadow-md overflow-hidden mx-2 my-3">
                                    <div className="nft-image position-relative overflow-hidden" style={{maxHeight:'337px'}}>
                                        <Link to={`/collection/${item.slug}`}><LazyImage src={item.logo_permalink} className="img-fluid" alt={item.slug} height='258px' style={{objectFit:'cover'}}/></Link>
                                        {item.categories && item.categories.length > 0 && (
                                          <div className="position-absolute top-0 start-0 m-3">
                                              {item.categories.map((category: Category) => (
                                                <CategoryBadge key={category.id} category={category} />
                                              ))}
                                          </div>
                                        )}                               
                                    </div>
        
                                    <div className="card-body content position-relative">
                                        <Link to={`/collection/${item.slug}`} className="title text-dark h6">{item.name}</Link>
        
                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                            {contract?.is_soldout ? (
                                              <small className="rate fw-bold">{t('collection.contracts.labels.soldout')}</small>
                                            ) : stage && (
                                              <small className="rate fw-bold">{formatSalePrice(stage.sale_price)}</small>
                                            )}
                                            <Link to={`/collection/${item.slug}`} className="btn btn-icon btn-pills btn-primary"><i className="uil uil-shopping-bag text-white"></i></Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            )
                          })}
                        </TinySlider>
                      </div>
                  </div>
              </div>
          </div>
          <div className="container mt-100 mt-60">
            <BestInfluencers params={{
                  category_slug: props.category.slug
            }} />
          </div>
        </section>
        <Footer/>
        </>
    );
};

export default DisplayTheme2;